export function getRedirectTarget(defaultTarget = '/'): string {
  const params = new URLSearchParams(window.location.search)
  const redirect = params.get('redirect')
  if (!redirect?.startsWith('/')) {
    return defaultTarget
  }
  return redirect
}

export function navigateTo(path: string) {
  window.location.assign(path)
}

export function getSearchToken(): string | null {
  const params = new URLSearchParams(window.location.search)
  return params.get('token')
}
